import { getApiKey } from '../services'

export const setApiKey = async (setReCaptchaApiKey: React.Dispatch<React.SetStateAction<string>>) => {
  const response = await getApiKey('gemvision-recaptchaV2-Key')
  setReCaptchaApiKey(response || 'undefined')
}
